export type HostKind = "app" | "admin";

export function detectHost(): HostKind {
  const adminBase = import.meta.env.VITE_ADMIN_BASE_URL ?? "";
  const adminHost = (() => {
    try {
      return new URL(adminBase).host.toLowerCase();
    } catch {
      return "";
    }
  })();
  const currentHost = window.location.host.toLowerCase();
  if (adminHost && currentHost === adminHost) return "admin";
  return "app";
}
